var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoodlePrestisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "fl"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.7,
    cy: -2.2,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 5.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -4.1,
    cy: 5.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6.7,
    cy: -2.2,
    r: 2.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "tu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6 -2 C-6 -8 0 -10 0 -3 C0 -10 6 -8 6 -2 C6 4 0 8 0 8 C0 8 -6 4 -6 -2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8 L0 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13 C3 11 7 13 5 16 C2 16 1 15 0 13 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11 Q-1 0 2 -11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 5 C-4 4 -3 -1 1 0 C3 1 3 3 1 5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 -1 C7 -2 7 -7 3 -6 C1 -5 1 -2 2 -1 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9,
    y: -3,
    width: 18,
    height: 13,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -3 L0 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 2 L9 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -3 C-3 -8 -7 -6 -5 -3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -3 C3 -8 7 -6 5 -3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ht"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8 C-6 3 -8 -2 -4 -5 C-1 -7 0 -4 0 -2 C0 -4 1 -7 4 -5 C8 -2 6 3 0 8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -3,
    rx: 6,
    ry: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.5 L-1.6 7 L1.6 7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7 Q2.5 11 -0.5 14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-7 -5 -8 5 -1 1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7 -5 8 5 1 1 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "en"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9,
    y: -6,
    width: 18,
    height: 12,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9 -5 L0 2 L9 -5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "st"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -8 L2.2 -2.5 L8 -2.5 L3.3 1.2 L5 7 L0 3.4 L-5 7 L-3.3 1.2 L-8 -2.5 L-2.2 -2.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -7 C0.6 -2.2 2.2 -0.6 7 0 C2.2 0.6 0.6 2.2 0 7 C-0.6 2.2 -2.2 0.6 -7 0 C-2.2 -0.6 -0.6 -2.2 0 -7 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "va"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5 3 L-4 11 L4 11 L5 3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 3 L5 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3 L0 -5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -7,
    r: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 1 L-6 -4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 1 L6 -4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -6.5,
    cy: -5.2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: -5.2,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "bf"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -4,
    cy: -3,
    rx: 4,
    ry: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: -3,
    rx: 4,
    ry: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -3.5,
    cy: 3.5,
    rx: 3.4,
    ry: 2.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.5,
    cy: 3.5,
    rx: 3.4,
    ry: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -6 L0 6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ro"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -1 C2.5 -3 -1.5 -5 -3 -1.5 C-4.5 3 3 4.5 4.5 -1 C6.5 -7 -3 -9 -7 -3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7 -3.5 C-10 1.5 -3 8 4 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5 L0 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9 C3 7 6 9 4 12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dt"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#941d59",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fl",
    transform: "translate(20,16) rotate(8) scale(1.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lf",
    transform: "translate(70,24) rotate(35) scale(0.95)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gf",
    transform: "translate(126,18) rotate(-6) scale(0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ht",
    transform: "translate(160,13) rotate(15) scale(1.35)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sp",
    transform: "translate(214,22) scale(1.1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ba",
    transform: "translate(28,58) rotate(-10) scale(1.15)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bw",
    transform: "translate(66,66) rotate(10) scale(1.3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#en",
    transform: "translate(122,54) rotate(-4) scale(0.85)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fl",
    transform: "translate(174,64) rotate(40) scale(0.7)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#va",
    transform: "translate(212,58) scale(1.05)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ht",
    transform: "translate(18,104) rotate(-12) scale(0.9)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#st",
    transform: "translate(74,96) rotate(18) scale(1.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tu",
    transform: "translate(116,102) rotate(-8) scale(1.1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bf",
    transform: "translate(170,98) rotate(6) scale(1.3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dt",
    transform: "translate(214,108) scale(1.6)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#en",
    transform: "translate(26,144) rotate(5) scale(1.0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fl",
    transform: "translate(70,134) rotate(22) scale(1.4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#va",
    transform: "translate(124,142) scale(0.9)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ro",
    transform: "translate(166,138) rotate(-15) scale(1.15)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ht",
    transform: "translate(216,146) rotate(12) scale(0.8)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#st",
    transform: "translate(20,182) rotate(-20) scale(1.1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tu",
    transform: "translate(72,176) rotate(10) scale(0.85)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bw",
    transform: "translate(118,186) rotate(-8) scale(1.0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sp",
    transform: "translate(168,180) scale(1.45)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gf",
    transform: "translate(214,178) rotate(6) scale(0.95)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lf",
    transform: "translate(24,222) rotate(-30) scale(1.2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#va",
    transform: "translate(70,224) scale(1.1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ht",
    transform: "translate(122,216) rotate(20) scale(1.3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fl",
    transform: "translate(170,224) rotate(50) scale(0.95)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#st",
    transform: "translate(216,220) rotate(-10) scale(0.85)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoodlePrestisa);
export default __webpack_public_path__ + "static/media/doodle-prestisa.7c00408ac1fba2cc25f303986a63bca8.svg";
export { ForwardRef as ReactComponent };